import * as React from "react";
import QueryHelper from "components/common/QueryHelper";
const queryExample = /* @__PURE__ */ React.createElement("p", null, "Find report containing critical in the description:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "pattern:critical"), /* @__PURE__ */ React.createElement("br", null));
const fieldMap = {
  subtitle: "The subtitle of the report",
  description: "The description of the report"
};
const ReportQueryHelper = () => /* @__PURE__ */ React.createElement(QueryHelper, { example: queryExample, entityName: "report", commonFields: ["title"], fieldMap });
export default ReportQueryHelper;
